// NICE brand lockup: official circular logo image (Nexoria Institute of Cardiometabolic Excellence).
const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/nice-logo.png`;

export const NiceLogo = ({ size = "md", className = "" }) => {
  const dim = size === "lg" ? "w-56 h-56 sm:w-72 sm:h-72" : size === "sm" ? "w-20 h-20" : "w-40 h-40";
  return (
    <div className={`flex flex-col items-center ${className}`} data-testid="nice-logo">
      <img
        src={LOGO_SRC}
        alt="NICE — Nexoria Institute of Cardiometabolic Excellence, by Vigyaved"
        className={`${dim} rounded-full object-cover shadow-xl ring-1 ring-white/10`}
        loading="eager"
      />
    </div>
  );
};

export const NiceMark = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`} data-testid="nice-mark">
    <img
      src={LOGO_SRC}
      alt="NICE"
      className="w-8 h-8 rounded-full object-cover ring-1 ring-white/20"
      loading="eager"
    />
    <span className="font-display font-extrabold tracking-[0.1em] text-lg text-vv-gold2">NICE</span>
  </span>
);
